import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useTracking } from './useTracking'

export const usePageTracking = () => {
  const location = useLocation()
  const { trackPageView } = useTracking()

  useEffect(() => {
    // Google Analytics tracking
    if (typeof (window as any).gtag === 'function') {
      ;(window as any).gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
      })
    }

    // Centralized page tracking
    trackPageView(location.pathname, location.search, location.hash)
  }, [location, trackPageView])
}
